'use strict';

angular.module('far.models.news', [])
    .service('News', function ($log, $http) {
        this.new = function (data) {
            return new News(data);
        };

        this.delete = function (route, callback) {
            return $http.delete(Routing.generate('api_delete_news', {news: route.id}))
                .then(function () {
                    route = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.restore = function (route) {
            return $http.patch(Routing.generate('api_patch_news', {id: route.id}))
                .then(function () {
                    return route = null;
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.getView = function (routeId, callback) {
            var route = new News({});

            $http.get(Routing.generate('api_get_newsview', {news: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        this.get = function (routeId, callback) {
            var route = new News({});

            $http.get(Routing.generate('api_get_news', {news: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        function News(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_put_news', {news: this.id}) :
                                Routing.generate('api_post_news');

                        // TODO: Грязный хак
                        var data = angular.merge({}, this);

                        if ( angular.isArray( data.disciplines ) ) {
                            data.disciplines = data.disciplines.map(function(discipline) {
                                return discipline.id;
                            });
                        }

                        if ( angular.isArray( data.categories ) ) {
                            data.categories = data.categories.map(function(category) {
                                return category.id;
                            });
                        }

                        if ( angular.isArray( data.committees ) ) {
                            data.committees = data.committees.map(function(committee) {
                                return committee.id;
                            });

                        if ( angular.isObject( data.avatar ) ) {
                            data.avatar = data.avatar.id;
                        }

                        return $http[method](url, data);
                    }
                }
            }});
        }
    });
